// extracted by mini-css-extract-plugin
export var externalLink = "_f4-0";
export var internalLinkLabel = "_f4-1";